import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FaShoppingCart, FaLock, FaUser } from 'react-icons/fa';
import Layout from '../../components/Layout';
import OrderView from './components/OrderView';
import ChangePasswordView from './components/ChangePasswordView';
import CustomerInfoView from './components/CustomerInfoView';
import { CiLogout } from 'react-icons/ci';
import { initUserInfo } from '../../redux/userInfo';
import { useDispatch } from 'react-redux';

const Container = styled.div`
  display: flex;
  gap: 5rem;
  max-width: 1200px;
  margin: 2rem auto;
  padding: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Sidebar = styled.div`
  width: 250px;
  border-right: 1px solid #ddd;
  padding-right: 1rem;

  @media (max-width: 768px) {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #ddd;
    padding-bottom: 1rem;
  }
`;

const TabButton = styled.button`
  display: flex;
  width: 100%;
  gap: 15px;
  padding: 12px;
  margin-bottom: 8px;
  justify-content: flex-end;
  border: none;
  background: ${(props) =>
    props.active ? props.theme.colors.subBackground : 'transparent'};
  color: ${(props) =>
    props.active
      ? props.theme.colors.primaryText
      : props.theme.colors.secondaryText};
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
  font-size: 14px;

  &:hover {
    background: ${(props) => props.theme.colors.subBackground};
    opacity: 0.7;
  }
`;

const ContentArea = styled.div`
  flex: 1;
  min-width: 0;
`;

const MyAccountPage = () => {
  const { page } = useParams(); // URL의 :page 부분을 가져옴
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const activeTab = page || 'orders'; // 기본값을 'orders'로 설정

  // 탭 변경 시 URL 업데이트

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token === 'null') {
      navigate('/');
    } else {
      // URL에 page 값이 없으면 기본값 'orders'로 리다이렉트
      if (!page) {
        navigate('/myaccount/orders', { replace: true });
      }
    }
  }, [page, navigate]);

  const handleTabChange = (tab) => {
    navigate(`/myaccount/${tab}`);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    dispatch(initUserInfo());
    navigate('/');
    window.location.reload();
  };

  return (
    <Layout>
      <Container>
        <Sidebar>
          {/* <TabButton
            active={activeTab === 'customer'}
            onClick={() => handleTabChange('customer')}
          >
            CUSTOMER INFO <FaUser />
          </TabButton> */}
          <TabButton
            active={activeTab === 'orders'}
            onClick={() => handleTabChange('orders')}
          >
            ORDERS <FaShoppingCart />
          </TabButton>
          <TabButton
            active={activeTab === 'password'}
            onClick={() => handleTabChange('password')}
          >
            CHANGE PASSWORD <FaLock />
          </TabButton>
          <TabButton
            active={activeTab === 'password'}
            onClick={() => handleLogout()}
          >
            Log out
            <CiLogout size={'18px'} />
          </TabButton>
        </Sidebar>

        <ContentArea>
          {activeTab === 'customer' && <CustomerInfoView />}
          {activeTab === 'orders' && <OrderView />}
          {activeTab === 'password' && <ChangePasswordView />}
        </ContentArea>
      </Container>
    </Layout>
  );
};

export default MyAccountPage;
